module.exports = __webpack_public_path__ + "img/home-case-08.64976183.png";